import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RefreshauthService {

  constructor(private http:HttpClient) { }
  refreshPersonAuth(orgId:string,personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //PATCH    /person/{personId}/orguser/refreshauth	worktrest	auth_{userId}	
    return this.http.patch<any>(environment.apiUrl+'/organization/'+orgId+'/person/'+personId+'/orguser/refreshauth','',httpOptions)
  }


  refreshCustomerAuth(orgId:string,personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
  //PATCH /organization/{organizationId}/customer/{customerId}/user/{userId}/refreshauth
    return this.http.patch<any>(environment.apiUrl+'/organization/'+orgId+'/customer/'+JSON.parse(SessionHelper.getCustomer()).customerId.split('_')[0]+'/user/'+personId+'/refreshauth','',httpOptions)
  }
}